import {HTH} from "../HTH";

export class ReelFrameElements extends PIXI.Container {

    private _reelFrameLeft: PIXI.Sprite;
    private _reelFrameRight: PIXI.Sprite;

    constructor() {
        super();
        this.name = "ReelFrame";
        this.init();
    }

    private init() {
        this._reelFrameLeft = new PIXI.Sprite(HTH.assetLoader.getTextures("reelFrame")[0]);
        this._reelFrameLeft.anchor.set(0.5, 0.5);
        this._reelFrameLeft.position.set(-7, 382);
        this._reelFrameLeft.scale.set(-0.68, 0.68);
        this._reelFrameLeft.name = "reelFrameLeft";
        this.addChild(this._reelFrameLeft);

        this._reelFrameRight = new PIXI.Sprite(HTH.assetLoader.getTextures("reelFrame")[0]);
        this._reelFrameRight.anchor.set(0.5, 0.5);
        this._reelFrameRight.position.set(727, 382);
        this._reelFrameRight.scale.set(0.68, 0.68);
        this._reelFrameRight.name = "reelFrameRight";
        this.addChild(this._reelFrameRight);

    }

}